
import { defineComponent, ref } from "vue";
import { activators } from "@/api/ai"; 
import ActivateAi from "./ActivateAi.vue";

export default defineComponent({
  name: "ai-activators", 
  components: {   
    ActivateAi
  },
  data() {
    return { 
      list: [],
      loading: true, 
      selectedRecid: 0,
      activation: {},
      showModal: false
    };
  },
  methods: {
    async activatorsList() { 
      this.loading = true;
      const response = await activators(1);
      this.list = response.data.pageList;
      this.loading = false;
    },
    activateAi(recid: number, item: any) {
      //console.log("Activating AI for recid:", recid);
      this.selectedRecid = recid;
      this.activation = item;

      //add delay to allow data binding to complete. make sure modal shows correct data
      setTimeout(() => {
        const btn2:any = this.$refs.activateAiButton;
        btn2.click();
        this.showModal = true;
       }, 200); // 200ms delay
    }
  },
  mounted() {
    this.activatorsList();
  }, 
  props: {
    widgetClasses: String
  }
});
